import { createRoute } from '@tanstack/react-router';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import TfgPage from '@/features/dashboard/tfg/pages/TfgPage.tsx';

export const tfgRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/tfg',
  component: TfgPage,
});
